import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowsCrossOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="m.5 8 2.807-2.807.99.99L3.18 7.3H7.3V3.18L6.183 4.297l-.99-.99L8 .5l2.807 2.807-.99.99L8.7 3.18V7.3h4.12l-1.117-1.117.99-.99L15.5 8l-2.807 2.807-.99-.99L12.82 8.7H8.7v4.12l1.117-1.117.99.99L8 15.5l-2.807-2.807.99-.99L7.3 12.82V8.7H3.18l1.117 1.117-.99.99z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
ArrowsCrossOutlinedSize16Glyph.displayName = 'ArrowsCrossOutlinedSize16Glyph';
